export const APP_CONFIG = {
    API_URL: import.meta.env.VITE_API_URL || 'http://localhost:8080',
    CLERK_PUBLISHABLE_KEY: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || 'pk_test_ZGVhci1jb3JhbC0yOS5jbGVyay5hY2NvdW50cy5kZXYk',
    RESEND_API_KEY: import.meta.env.VITE_RESEND_API_KEY! || 're_5smTooLP_H1sdnXycQa4dSvCWjLicxdtA',
    STRIPE_CUSTOMER_PORTAL_URL: import.meta.env.VITE_STRIPE_CUSTOMER_PORTAL_URL || '',
    UMAMI_WEBSITE_ID: import.meta.env.VITE_UMAMI_WEBSITE_ID || '',
    SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || '',
    POSTHOG_API_KEY: import.meta.env.VITE_POSTHOG_API_KEY || '',
}
